"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicMerchantContract = void 0;
const contract_1 = require("../base/contract");
const merchant_schemas_1 = require("../../schemas/public/merchant.schemas");
const api_schemas_1 = require("../../schemas/base/api.schemas");
/**
 * Public Merchant Contract
 *
 * Story: 3.6 - Merchant Registration Link Generation (MVP)
 *
 * Purpose: Lookup merchant by slug for customer registration flow
 * - No authentication required
 * - Only returns basic public merchant info (id, name, logo)
 * - Used by customer registration links (e.g., /join/cafe-luna)
 */
exports.PublicMerchantContract = (0, contract_1.createContract)({
    name: 'PublicMerchant',
    baseUrl: '/public/merchants',
    version: '1',
    serviceModule: 'merchant',
    endpoints: {
        getMerchantBySlug: {
            method: 'GET',
            path: '/by-slug/:slug',
            body: null,
            query: null,
            params: merchant_schemas_1.getMerchantBySlugParamsSchema,
            headers: null,
            response: {
                success: merchant_schemas_1.getMerchantBySlugResponseSchema,
                errors: {
                    notFound: api_schemas_1.baseErrorResponseSchema, // Slug not found or merchant disabled
                },
            },
            middleware: [], // No auth required - public endpoint
            documentation: {
                summary: 'Get merchant by slug',
                description: 'Lookup merchant information by slug for customer registration. Returns basic public info (id, name, logo). Only active merchants are returned.',
                tags: ['Public', 'Merchants'],
                deprecated: false,
            },
            tests: [
                'should return merchant info for valid slug',
                'should return 404 for non-existent slug',
                'should return 404 for disabled merchant',
                'should work without authentication',
            ],
        },
    },
});
